<template>
  <div id="mikmak-site">
    <Header></Header>
    <Holiday2019></Holiday2019>
    <CookieBanner></CookieBanner>
  </div>
</template>

<script>

import Header from '../components/site/Header/Header'
import Holiday2019 from '../components/site/Whitepaper/Holiday2019'
import CookieBanner from '../components/CookieBanner'

import eventDispatcher from '../events/dispatch'

export default {
  components: {
    Header,
    Holiday2019,
    CookieBanner
  },
  data() {
    return {
      attachTitle: 'MikMak Attach',
      attachSubtitle: 'Improving the post-click and swipe-up commerce experience across every social channel and the open web.',
      studiosTitle: 'MikMak Studios',
      studiosSubtitle: 'Full-service production specialized in fun, short-form product videos.'
    }
  },
  mounted() {
    document.addEventListener('touchstart', function(){}, true);
    eventDispatcher('pageView')
  },
  computed: {
    attachProducts() {
      return this.$store.state.attachProducts
    },
    studiosProducts() {
      return this.$store.state.studiosProducts
    }
  }
}

</script>

<style scoped>
  .mikmak-site {
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// Holiday2019.vue?0088db57